'use strict';

var loqate = {};
var util = require('./util');
/**
 * @function
 * @description init events for the loqate
 */
loqate.init = function ($form) {
	try {
		if (SitePreferences.CHECK_LOQATE) {
			window.pca.load();
		}
	} catch (e) {
		window.console.log(e);
	}

	$form.on('click', '.enter-manually', function () {
		$('.full-address').slideDown('slow').addClass('active');
		$(this).addClass('active');
		$('.complete-address').hide();
		$('.addressy .input-text').val('');
	});
	$form.on('hide', '.addressy .input-text', function () {
		$('.full-address').slideUp('slow').removeClass('active');
		$('.enter-manually').removeClass('active');
	});
	$form.on('click', '.edit-adressy', function () {
		$('.complete-address').hide();
		$('.enter-manually').trigger('click');
	});

	// listen for autopopulate of addressy inputs
	$form.find('#dwfrm_addressy_addressFind').on('animationstart', function (e) {
		if (e) {
			e.preventDefault();
			$(this).val('').change();
		}
		window.console.debug('animationstart', e);
	});

	// on init add complete-address div to addressy section
	if (!$form.find('.addressy .field-wrapper .complete-address').length) {
		$form.find('.addressy .field-wrapper').append('<div class="complete-address"></div>');
		$form.find('.addressy .field-wrapper .complete-address').hide();
	}
	// TODO: need to pass $form all the time, it not right to use local selectors here
	loqate.updateAddressDescriptionWithForm($form);
	util.addMaskAttr('.addressy .complete-address .pcadescription, .pca.pcalist .pcaitem');
};

loqate.updateAddressDescriptionWithForm = function ($form) {
	// build selected block when address populated
	var dataFields = [];
	if (!$form || !$form.length) {
		window.console.debug('No form for loqate provided', $form);
		return dataFields;
	}

	$form.find('.full-address input').each(function (i, el) {
		if (!!$(el).val() && i < 10) {
			dataFields.push($(el).val());
		}
	});

	dataFields.push($form.find('[name$="_country"]').val());
	if (dataFields.length >= 3) {
		selectedAddressBlock(dataFields);
	}

	return dataFields;
};

// update address data
function selectedAddressBlock(addressFields) {
	if (addressFields.length > 0) {
		var content = '<div class="pcadescription" data-cs-mask>' + addressFields.join('<br/>') + '</div>';
		var editBtn = '<span class="edit-adressy">edit</span>';
		$('.addressy .complete-address').html(content + editBtn);
		$('input[name$="_addressFind"]').val('');

		// hide address section?
		// $('.full-address').slideUp('slow').removeClass('active');
		// show short address only when full is hidden
		if (!$('.full-address').hasClass('active')) {
			$('.complete-address').show();
		}
	}
}

loqate.load = function () {
	try {
		if (SitePreferences.CHECK_LOQATE) {
			if (typeof window.pca.load === 'function') {
				window.pca.on('load', function (type, id, control) {
					control.options.minSearch = 1;
					control.listen('populate', function (address) { // variations second parameter
						try {
							var fields = ['Company', 'FormattedLine1', 'Line2', 'City', 'ProvinceName', 'PostalCode', 'CountryIso2'];
							window.console.debug(address);
							var addressFields = [];
							for (var i = 0, field; i < fields.length; i++) {
								field = fields[i];
								if (address[field]) {
									addressFields.push(address[field]);
								}
							}
							selectedAddressBlock(addressFields);
							// handle postal code value update address.PostalCode
							if (!address) {
								return window.console.log('no address', address);
							}
							if (address.PostalCode) {
								$('input[name$="_zip"], input[name$="_postal"]').val(address.PostalCode);
							}
							// Province IL ProvinceName Illinois
							if (address.ProvinceName) {
								$('input[name$="_county"]').val(address.ProvinceName);
							}
							if (address.ProvinceCode) {
								$('select[name$="states_state"]').val(address.ProvinceCode.toUpperCase()).trigger('change');
							}
						} catch (e) {
							window.console.error(e);
						}
					});
					control.listen('display', function() {
						$('.pca.pcalist .pcaitem').attr('data-cs-mask', '');
					});
				});
				window.pca.load();
			} else {
				window.setTimeout(loqate.load, 1000);
			}
		}
	} catch (e) {
		window.console.log(e);
	}
};

module.exports = loqate;
